/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountEphemeralCredentialsForZohoServiceDeskCloud extends models.ServiceAccountEphemeralCredentialsBase {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountEphemeralCredentialsForZohoServiceDeskCloud");
    }

    getFixupPrototypeFunction() { return ServiceAccountEphemeralCredentialsForZohoServiceDeskCloud.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountEphemeralCredentialsForZohoServiceDeskCloud>): ServiceAccountEphemeralCredentialsForZohoServiceDeskCloud {
        let obj = Object.assign(new ServiceAccountEphemeralCredentialsForZohoServiceDeskCloud(), model);
        ServiceAccountEphemeralCredentialsForZohoServiceDeskCloud.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountEphemeralCredentialsForZohoServiceDeskCloud>): ServiceAccountEphemeralCredentialsForZohoServiceDeskCloud {
        if (!model) return null;
        return ServiceAccountEphemeralCredentialsForZohoServiceDeskCloud.newInstance(<ServiceAccountEphemeralCredentialsForZohoServiceDeskCloud> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountEphemeralCredentialsForZohoServiceDeskCloud) {
        if (!obj) return;

        models.ServiceAccountEphemeralCredentialsForZohoServiceDeskCloud.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountEphemeralCredentialsForZohoServiceDeskCloud): boolean {
        if (models.ServiceAccountEphemeralCredentialsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountEphemeralCredentialsForZohoServiceDeskCloud.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Access Token
     */
    access_token: string;

}
